(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["tr-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tr-delivery-estimate')) {
    customElements.define(
      'tr-delivery-estimate',
      class extends HTMLElement {
        connectedCallback() {
          const days = parseInt(this.dataset.days, 10);
          const out = this.querySelector('.tr-delivery__dates');
          if (!out || isNaN(days) || days < 1) return;
          const now = new Date();
          const d = new Date(now);
          let left = days;
          while (left > 0) {
            d.setDate(d.getDate() + 1);
            const w = d.getDay();
            if (w !== 0 && w !== 6) left--;
          }
          const tomorrow = new Date(now);
          tomorrow.setDate(now.getDate() + 1);
          if (d.toDateString() === tomorrow.toDateString()) {
            out.textContent = 'tomorrow';
            return;
          }
          let fmt;
          try {
            fmt = new Intl.DateTimeFormat(this.dataset.locale || undefined, { weekday: 'long' });
          } catch (e) {
            fmt = new Intl.DateTimeFormat(undefined, { weekday: 'long' });
          }
          out.textContent = fmt.format(d);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tr-size-guide-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tr-modal-trigger')) {
    customElements.define(
      'tr-modal-trigger',
      class extends HTMLElement {
        connectedCallback() {
          const dialog = this.querySelector('dialog');
          const opener = this.querySelector(':scope > button');
          if (!dialog || !opener) return;
          opener.addEventListener('click', () => {
            dialog.showModal();
            document.documentElement.style.overflow = 'hidden';
          });
          dialog.addEventListener('close', () => {
            document.documentElement.style.overflow = '';
            opener.focus();
          });
          dialog.addEventListener('click', (e) => {
            if (e.target === dialog || e.target.closest('[data-close]')) dialog.close();
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
